export const WHATSAPP_NUMBER = "5521982430311";
export const WHATSAPP_DISPLAY = "(21) 98243-0311";

export const fmtBRL = (value) =>
  (Number(value) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const installment12 = (value) => fmtBRL((Number(value) || 0) / 12);

export const discountPct = (price, promo) =>
  promo && promo < price ? Math.round((1 - promo / price) * 100) : 0;

export function buildWhatsAppUrl(message, number = WHATSAPP_NUMBER) {
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

/** URL pública permanente do produto (sempre o domínio oficial, mesmo no preview). */
export const productPublicUrl = (productId, domain) =>
  `https://${(domain || "comprenahg.com.br").replace(/^https?:\/\//, "")}/produto/${productId}`;

/** Mensagem de interesse com o produto identificado: nome exato, cor selecionada e link real. */
export function buildProductInterestMessage({ product, color, domain }) {
  const lines = [
    "Olá! Tenho interesse neste produto:",
    product.name,
    ...(color ? [`Cor: ${color}`] : []),
    productPublicUrl(product.id, domain),
  ];
  return lines.join("\n");
}

export function buildOrderMessage({ customer, items, subtotal, deliveryFee, total, regionName, note }) {
  const lines = [];
  lines.push("*NOVO PEDIDO — HG MÓVEIS*");
  lines.push("");
  lines.push(`*Cliente:* ${customer.name}`);
  lines.push(`*Cidade:* ${customer.city}`);
  lines.push(`*Bairro:* ${customer.neighborhood}`);
  lines.push("");
  lines.push("*Itens do pedido:*");
  items.forEach((item, i) => {
    const colorPart = item.color ? ` | Cor: ${item.color}` : "";
    lines.push(
      `${i + 1}. ${item.name}${colorPart} | Qtd: ${item.qty} | ${fmtBRL(item.unit_price)} un. = ${fmtBRL(item.total)}`
    );
  });
  lines.push("");
  lines.push(`*Subtotal:* ${fmtBRL(subtotal)}`);
  lines.push(`*Entrega${regionName ? ` (${regionName})` : ""}:* ${deliveryFee > 0 ? fmtBRL(deliveryFee) : "Grátis"}`);
  lines.push(`*TOTAL:* ${fmtBRL(total)}`);
  if (note) {
    lines.push("");
    lines.push(`*Observações:* ${note}`);
  }
  lines.push("");
  lines.push("Pagamento na entrega: PIX, dinheiro, débito ou crédito em até 12x sem juros.");
  return lines.join("\n");
}
